import { useState, useEffect } from 'react';
import verificareToken from '../VerificareToken';

function DrepturiUtilizator() {
  const [isLoading, setIsLoading] = useState(true);
  const [permisions, setPermissions] = useState([]);
  const [modificareDosarAccess, setModificareDosarAccess] = useState({});
  const [currentDosarId, setCurrentDosarId] = useState(null);
  const [fetchInProgress, setFetchInProgress] = useState(false);
  const { token } = verificareToken();

  const getUserID = () => {
    const user_id_local = localStorage.getItem('iduser');
    const user_id_session = sessionStorage.getItem('iduser');
    const user_id = user_id_local || user_id_session || null;
    return user_id;
  };

  useEffect(() => {
    const user_id = getUserID();
    async function fetchPermissions() {
      try {
        const response = await fetch(`${window.API_URL}getUserAllPermissionsAccess?user_id=${user_id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Eroare conexiune');
        }

        const data = await response.json();
        if (data && data.data && data.data.permisions) {
          setPermissions(data.data.permisions);
        }
      } catch (error) {
        console.error('Eroare la preluare drepturi:', error);
      }
    }

    if (user_id) {
      fetchPermissions();
    }
  }, [token]);

  const fetchDosarAccess = async (idDosar) => {
    const user_id = getUserID();
    if (idDosar && user_id) {
      try {
        const response = await fetch(`${window.API_URL}getUserPermissionAccess?dosar_id=${idDosar}&user_id=${user_id}&right=DreptDeModificareDosare`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        if (!response.ok) throw new Error('Eroare API drept dosar');

        const data = await response.json();
        if (data && data.data) {
          setModificareDosarAccess({ [idDosar]: data.data.access }); // ⚡ păstrăm doar ultimul
        }
      } catch (error) {
        console.error('Eroare API drept dosar:', error);
        setModificareDosarAccess({ [idDosar]: false });
      } finally {
        setFetchInProgress(false);
      }
    }
  };

  useEffect(() => {
    if (window.location.pathname.startsWith('/editare-dosar/')) {
      const parts = window.location.pathname.split('/editare-dosar/');
      const idDosar = parts[1] ? parts[1].split('/')[0] : null;
      if (idDosar) {
        setCurrentDosarId(idDosar);
        setModificareDosarAccess({});
        fetchDosarAccess(idDosar);
      }
    }
  }, [token]);

  const areDrept = (denumireDrept, idDosar = null) => {
    if (denumireDrept === "DreptDeModificareDosare") {
      // Dacă idDosar nu e primit, încearcă să-l ia din URL
      if (!idDosar && window.location.pathname.startsWith('/editare-dosar/')) {
        const parts = window.location.pathname.split('/editare-dosar/');
        idDosar = parts[1] ? parts[1].split('/')[0] : null;
      }
  
      if (idDosar) {
        if (!modificareDosarAccess.hasOwnProperty(idDosar) && !fetchInProgress) {
          setFetchInProgress(true);
          fetchDosarAccess(idDosar);
        }
        return modificareDosarAccess[idDosar] ?? false;
      }
    }
  
    const permission = permisions.find((p) => p.right === denumireDrept);
    return permission ? permission.acces : false;
  };
  

  useEffect(() => {
    if (permisions.length >= 0) {
      setIsLoading(false);
    }
  }, [permisions]);

  return { areDrept, isLoading };
}

export default DrepturiUtilizator;
